import React from 'react'
import { View } from 'react-native'

import { useRouter } from 'expo-router'

import { NavCard } from '@/screens/diamonds/components/NavCard'

interface RewardsCardProps {
  compact?: boolean
}

export function RewardsCard({ compact = false }: RewardsCardProps) {
  const router = useRouter()

  const showHeader = compact == true ? true : false
  const isClickable = compact == true ? true : false
  const scrollEnabled = compact == true ? false : true

  return (
    <NavCard
      title="Rewards"
      handler={() => router.push('/diamonds/rewards')}
      showHeader={showHeader}
      isClickable={isClickable}
      scrollEnabled={scrollEnabled}
    >
      { compact !== true &&
        <View />
      }
    </NavCard>
  )
}
